import { monitorError } from "@/js/plugins/monitoring";

export const manageError = (error) => {
	monitorError(error, { properties: { errorSource: "manageError" } });

	console.error(
		"Internal Error. The code most likely failed because a developer made a syntax-error.\n\nError:\n",
		error
	);
	throw error;
};
